import type { NetbeheerderDiscipline } from '../../../valuelists/types/NetbeheerderDiscipline'

export { isNetbeheerderDisciplineEqual, formatNetbeheerderDisciplineLabel }

function isNetbeheerderDisciplineEqual(
  option: NetbeheerderDiscipline,
  value: NetbeheerderDiscipline,
): boolean {
  return (
    `${option.netbeheerderLabel} - ${option.disciplineLabel}` ===
    `${value.netbeheerderLabel} - ${value.disciplineLabel}`
  )
}

function formatNetbeheerderDisciplineLabel(
  option: NetbeheerderDiscipline,
): string {
  return `${option.netbeheerderLabel} - ${option.disciplineLabel}`
}
